module.exports = __webpack_public_path__ + "media/images/promotion-1-5dd5c9d87a0a1cfa71ad01426eb54088.png";